exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-right[data-v-12b3b3de]{vertical-align:middle}.search-right label[data-v-12b3b3de]{margin-right:1em}.search-right label input[data-v-12b3b3de]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12b3b3de","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/office/jobs/ReportMissingHandoverComponent.vue
// module id = G+fU
// module chunks = 0